<template>
  <div v-if="items && items.length > 0">
    <CustomTable
      :items="items"
      :fields="fields"
      :add_new_button="false"
      :filter_payment_button="true"
      :filter_status_button="true"
      @handlerSort="handlerSort"
      @handlerDelete="handlerDelete"
    />
  </div>
  <div v-else>
    <no-data />
  </div>
</template>
<script>
/* eslint-disable array-callback-return */
// import { BTabs, BTab } from 'bootstrap-vue'
import Request from '@/plugins/service/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import general from '@/mixins/index'
import statusList from '@/mixins/status.json'

export default {
  components: {
    // BTabs,
    // BTab,
  },
  mixins: [general],
  data() {
    return {
      fields: [
        { key: 'order_no', label: 'Order no', sortable: false },
        { key: 'created_at_utc', label: 'Created at', sortable: true },
        // { key: 'address', label: 'Address', sortable: true },
        { key: 'fullname', label: 'Fullname', sortable: true },
        { key: 'status_no', label: 'Status', sortable: false },
        { key: 'totalF', label: 'Total', sortable: true },
        { key: 'payment_type_text', label: 'Payment Status', sortable: true },
        // { key: 'lang', label: 'Language', sortable: false },
        { key: 'more', label: 'Tool', sortable: false },
        // { key: 'sort', label: 'Reorder', sortable: false },
      ],
      tabReturnRefund: [
        {
          id: 7,
          name: 'Return',
          count: 0,
          note: 'Trạng thái đang chuyển hàng trả lại',
          items: [],
        },

        {
          id: 8,
          name: 'Refund',
          count: 0,
          note: 'Trạng thái đang đợi chuyển tiền lại cho seller',
          items: [],
        },

        {
          id: 9,
          name: 'Refund processed',
          count: 0,
          note: 'Trạng thái đã trả tiền lại cho seller',
          items: [],
        },
      ],
      tabList: [
        {
          id: 0,
          name: 'All',
          count: 0,
          note: 'All',
          items: [],
        },
        {
          id: 1,
          name: 'Waiting for confirmation',
          count: 0,
          note: 'Đợi xác nhận',
          items: [],
        },
        {
          id: 2,
          name: 'To process',
          count: 0,
          note: 'Chưa xử lý',
          items: [],
        },
        {
          id: 3,
          name: 'Processed',
          count: 0,
          note: 'Đã xử lý',
          items: [],
        },
        {
          id: 4,
          name: 'Shipping',
          count: 0,
          note: 'Đang giao hàng',
          items: [],
        },
        {
          id: 5,
          name: 'Completed',
          count: 0,
          note: 'Đã giao hàng xong, khách đã nhận được hàng',
          items: [],
        },
        {
          id: 6,
          name: 'Cancel',
          count: 0,
          note: 'Khách huỷ đơn hàng, khách được huỷ ở bước 1,2',
          items: [],
        },
        // {
        //   id: 7,
        //   name: 'Return/Refund',
        //   count: 0,
        //   note: 'Trạng thái đang chuyển hàng trả lại',
        //   items: [],
        // },

        // {
        //   id: 8,
        //   name: 'Refund',
        //   count: 0,
        //   note: 'Trạng thái đang đợi chuyển tiền lại cho seller',
        //   items: [],
        // },

        // {
        //   id: 9,
        //   name: 'Refund processed',
        //   count: 0,
        //   note: 'Trạng thái đã trả tiền lại cho seller',
        //   items: [],
        // },
      ],
      items: [],
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async handlerSort(data) {
      const { item } = data
      const { method } = data
      try {
        const params = {
          site_id: JSON.parse(localStorage.getItem('siteID')).id,
          type: 1,
          ids: [],
        }
        if (method === 'up') {
          params.ids = [item.item.id, this.items[item.index - 1].id]
        }
        if (method === 'down') {
          params.ids = [item.item.id, this.items[item.index + 1].id]
        }
        if (method === 'change') {
          params.type = 2
          params.ids = [
            {
              id: item.item.id,
              position: Number(item.item.position),
            },
          ]
        }
        const res = await Request.post(
          this.$http,
          `${process.env.VUE_APP_API_URL}/order/change_position`,
          params,
        )
        if (res.status === 200) {
          if (res.data.status) {
            this.loadList()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Opps! Something wrong',
                icon: 'AlertOctagonIcon',
                variant: 'danger',
                text: String(this.showError(res.data.error, ',')),
              },
            })
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Opps! Something wrong',
            icon: 'AlertOctagonIcon',
            variant: 'danger',
            text: String(error),
          },
        })
      }
    },
    async loadList() {
      const siteId = JSON.parse(localStorage.getItem('siteID')).id
      try {
        const res = await Request.get(
          this.$http,
          `${process.env.VUE_APP_API_URL}/orders?site_id=${siteId}`,
        )
        if (res.status === 200) {
          if (res.data.status) {
            const mapData = []
            res.data.data.map(val => {
              mapData.push({
                ...val,
                created_at_utc: val.created_at,
                status: statusList.filter(x => x.id === val.status)[0].key,
                status_no: statusList.filter(x => x.id === val.status)[0].id,
                totalF: Number(val.total) + Number(val.shipping_price) - Number(val.coupon_discount),
              })
            })
            // order Cancel
            this.items = await this.getDataTranslation(mapData.filter(x => x.status_no === 6), true)
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Opps! Something wrong',
                icon: 'AlertOctagonIcon',
                variant: 'danger',
                text: String(this.showError(res.data.error, ',')),
              },
            })
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Opps! Something wrong',
            icon: 'AlertOctagonIcon',
            variant: 'danger',
            text: String(error),
          },
        })
      }
    },
    async handlerDelete(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            const siteId = JSON.parse(localStorage.getItem('siteID')).id
            const res = await Request.delete(
              this.$http,
              `${process.env.VUE_APP_API_URL}/order/${id}?site_id=${siteId}`,
            )
            if (res.status === 200) {
              if (res.data.status) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Trademark has been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.loadList()
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Opps! Something wrong',
                    icon: 'AlertOctagonIcon',
                    variant: 'danger',
                    text: String(this.showError(res.data.error, ',')),
                  },
                })
              }
            }
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Opps! Something wrong',
                icon: 'AlertOctagonIcon',
                variant: 'danger',
                text: String(error),
              },
            })
          }
        }
      })
    },
  },
}
</script>
<style lang="sass">
.cus-tabs
  .nav.nav-tabs
    border-bottom: .5px solid #ccc
</style>
